import React from "react";
import { Formik, Form, Field } from "formik";
import { Modal, Button } from "react-bootstrap";


function isValidCIDR(cidr) {
    const cidrRegex = /^(\d{1,3}(\.\d{1,3}){3})(\/([0-9]|[1-2][0-9]|3[0-2]))$/;
    if (!cidrRegex.test(cidr)) return false;
    const [ip, range] = cidr.split("/");
    return ip.split(".").every(octet => {
        const n = parseInt(octet, 10);
        return n >= 0 && n <= 255;
    });
}


export default function IPRangeRestrictionForm({ initialValues, onSubmit, onCancel }) {
    const defaults = {
        id: 0,
        cidrBlock: "",
        scope: 0,
        userId: "",
        tenantId: "",
        description: "",
        isBlocked: false,
        ...initialValues
    };

    const validate = values => {
        const errors = {};
        if (!values.cidrBlock) {
            errors.cidrBlock = 'Requerido';
        } else if (!isValidCIDR(values.cidrBlock)) {
            errors.cidrBlock = 'Formato CIDR inválido';
        }
        if (!values.scope) errors.scope = 'Requerido';
        if (!values.userId) errors.userId = 'Requerido';
        return errors;
    };

    return (
        <Modal show onHide={onCancel}>
            <Formik initialValues={defaults} validate={validate} onSubmit={onSubmit}>
                {({ errors, values }) => (
                    <Form>
                        <Modal.Header closeButton>
                            <Modal.Title>{values.id ? "Editar" : "Agregar"} IP Range</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="form-group">
                                <label>CIDR</label>
                                <Field name="cidrBlock" className="form-control" />
                                {errors.cidrBlock && <div className="text-danger">{errors.cidrBlock}</div>}
                            </div>
                            <div className="form-group">
                                <label>Scope</label>
                                <Field name="scope" component="select" className="form-control">
                                    <option value={0}>Global</option>
                                    <option value={1}>Tenant</option>
                                    <option value={2}>Usuario</option>
                                </Field>
                            </div>
                            <div className="form-group">
                                <label>Descripción</label>
                                <Field name="description" className="form-control" />
                            </div>
                            <div className="form-group">
                                <label>UserId</label>
                                <Field name="userId" className="form-control" />
                            </div>
                            <div className="form-check">
                                <Field type="checkbox" name="isBlocked" className="form-check-input" />
                                <label className="form-check-label">Bloqueado</label>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={onCancel}>Cancelar</Button>
                            <Button type="submit" variant="primary">Guardar</Button>
                        </Modal.Footer>
                    </Form>
                )}
            </Formik>
        </Modal>
    );
}